import axios from '@/axios'
import store from '@/store'

// https://api.wanfangche.com/
const api = {
  list: '/api/v2/notice/list',
  read: '/api/v2/notice/read',
  count: '/api/v2/notice/count',
}

export const NoticeService = {
  timerInstance: null,
  getList(data) {
    return axios.get(api.list, { params: data }).then(res => {
      return Promise.resolve(res.data)
    })
  },
  read(data) {
    return axios.post(api.read, data).then(res => {
      return Promise.resolve(res.data)
    })
  },
  async getNum(data) {
    const response = await fetch('https://api.wanfangche.com/v2/notice/count?is_read=0', {
      method: 'get',
      headers: {
        Authorization: `${store.state.token}`
      }
    })
    const res = await response.json()
    return res.data
  },

  // 通知轮询
  async loop() {
    const _self = NoticeService

    const num = await _self.getNum()
    // store.dispatch('setNoticeNumber', store.state.noticeNum + 1)
    store.dispatch('setNoticeNumber', num)
    _self.timerInstance = clearTimeout(_self.timerInstance)
    _self.timerInstance = setTimeout(() => {
      _self.loop()
    }, 60 * 1000);

    return _self.timerInstance
  },
  // 停止轮询
  stopLoop() {
    const _self = NoticeService
    _self.timerInstance = clearTimeout(_self.timerInstance)
  }
}

export default NoticeService